import { useSelector } from 'react-redux'
import { Trans } from '../../atoms'
import ArticoliPersonalizzati from '../../molecules/ArticoliPersonalizzati/ArticoliPersonalizzati'
import ArticoliSenzaStampa from '../../molecules/ArticoliSenzaStampa/ArticoliSenzaStampa'
import LoadingSvg from '../../atoms/Loading/Loading'

const SalvatiPerDopo = ({
  carrelloLater,
  isLoading,
  MoveToMain,
  MoveToLater,
  Delete,
  setOpenModalNota,
  setId,
  setNota,
  setOpenNomeLavorazioneModal,
  setNomeLavorazione,
  setCodice,
  setOpenModalRimuovi,
  setOpenModalQuantita,
  MoveToMainPersonalizzazione,
  MoveToLaterPersonalizzazione,
  EliminaPersonalizzazione,
}) => {
  const { service_gift } = useSelector((state) => state.servicegift)

  return (
    <div className="salvati-per-dopo">
      <p className="salvati-per-dopo__title">
        <Trans chiave="Articoli salvati per dopo" /> (
        {!isLoading && carrelloLater ? carrelloLater.numero_righe : 0})
      </p>
      {isLoading ? (
        <LoadingSvg />
      ) : (
        <>
          {carrelloLater && carrelloLater.numero_righe > 0 && (
            <>
              <div className="salvati-per-dopo__block">
                <div className="salvati-per-dopo__block-head">
                  {(!service_gift || service_gift?.personalizzazione) && (
                    <p className="salvati-per-dopo__subtitle">
                      <Trans chiave="Articoli non personalizzati" />
                    </p>
                  )}
                </div>
                <ArticoliSenzaStampa
                  salvati={true}
                  righe={
                    carrelloLater?.righe_carrello_merce_neutra
                      ? carrelloLater.righe_carrello_merce_neutra
                      : []
                  }
                  MoveToMain={MoveToMain}
                  MoveToLater={MoveToLater}
                  Delete={Delete}
                  setOpenModalNota={setOpenModalNota}
                  setId={setId}
                  setNota={setNota}
                  setCodice={setCodice}
                  setOpenModalRimuovi={setOpenModalRimuovi}
                  setOpenModalQuantita={setOpenModalQuantita}
                />
              </div>

              {(!service_gift || service_gift?.personalizzazione) && (
                <ArticoliPersonalizzati
                  salvati={true}
                  righe={
                    carrelloLater?.personalizzazioni_carrello
                      ? carrelloLater.personalizzazioni_carrello
                      : []
                  }
                  MoveToMainPersonalizzazione={MoveToMainPersonalizzazione}
                  MoveToLaterPersonalizzazione={MoveToLaterPersonalizzazione}
                  MoveToLater={MoveToLater}
                  Delete={Delete}
                  setOpenModalNota={setOpenModalNota}
                  setOpenNomeLavorazioneModal={setOpenNomeLavorazioneModal}
                  setNomeLavorazione={setNomeLavorazione}
                  setId={setId}
                  setCodice={setCodice}
                  setNota={setNota}
                  setOpenModalRimuovi={setOpenModalRimuovi}
                  setOpenModalQuantita={setOpenModalQuantita}
                  EliminaPersonalizzazione={EliminaPersonalizzazione}
                />
              )}
            </>
          )}
        </>
      )}
    </div>
  )
}
export default SalvatiPerDopo
